import {createStyles} from '@mantine/core';
import React from 'react';

import MolstarViewer, {MolstarWrapperProps} from 'molbio/molstar/Viewer';

const useStyles = createStyles(() => ({
  viewer: {
    width: '100%',
    height: '100%',
    position: 'relative',
    minWidth: 10,
    minHeight: 10,
  },
}));

interface MolstarRendererProps {
  url: string;
  format: MolstarWrapperProps['format'];
}

export default function MolstarRenderer({url, format}: MolstarRendererProps): JSX.Element {
  const {classes} = useStyles();
  return <MolstarViewer url={url} format={format} className={classes.viewer} />;
}
